/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global document, Office, Word */



import axiosconfig from '../axios/axiosconfig'
Office.onReady((info) => {
    if (info.host === Office.HostType.Word || info.host === Office.HostType.Excel) {
        // Verifica il token di autenticazione
        checkAuthToken().then((isAuthenticated) => {
            console.log('isAuthenticated',isAuthenticated);
            if (!isAuthenticated) {
                showLoginPage();
            } else {
                showTiStimoPage();
            }
        });
    }
});

function checkAuthToken() {
  // Verifica se il token è valido (questo è un esempio di implementazione)
  return new Promise((resolve) => {
    const token = getTokenFromStorage();
    if(!token)
        resolve(false);

    axiosconfig.get('auth/user')
        .catch(error => {
            console.error(error);
            resolve(false);
        });
    resolve(true);
  });
}

function showLoginPage() {
  window.location.href = "login.html";
}

function showTiStimoPage() {
  window.location.href = "tistimo.html";
}

function getTokenFromStorage() {
  return localStorage.getItem("access_token");
}